import { render, staticRenderFns } from "./OutrasPraticas.vue?vue&type=template&id=64cc3cc7&scoped=true"
import script from "./OutrasPraticas.vue?vue&type=script&lang=js"
export * from "./OutrasPraticas.vue?vue&type=script&lang=js"
import style0 from "./OutrasPraticas.vue?vue&type=style&index=0&id=64cc3cc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cc3cc7",
  null
  
)

export default component.exports